const fr = {
  avisoLegal: "Brouillon indicatif généré à partir des données enregistrées dans NuvliPro. Il ne remplace pas le conseil d'un professionnel. Vérifiez-le avec votre comptable avant de le déposer.",
  lockPago: "Les exports pour le comptable sont une fonction payante.",
  imp: { IVA: "TVA", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Territoire commun", canarias: "Canaries", ceuta_melilla: "Ceuta et Melilla", foral_pv: "Pays basque", foral_navarra: "Navarre" },
  tipo: { autonomo: "Indépendant (personne physique)", sociedad: "Société" },
  q: { 1: "T1 · janv.–mars", 2: "T2 · avr.–juin", 3: "T3 · juil.–sept.", 4: "T4 · oct.–déc." },
  periodoT: "T{{n}} {{year}}",
  periodoP: "Acompte {{n}} {{year}}",
  sub: "{{imp}} et impôt sur le revenu par trimestre et bilan annuel",
  pie: "Les montants sont calculés automatiquement à partir de vos factures émises et des dépenses enregistrées chaque trimestre.",
  regimen: {
    proTitulo: "Offre Pro :",
    proTexto: "régime fiscal automatique par territoire (TVA, IGIC et Haciendas Forales), Modèle 420 aux Canaries, Modèle 202 pour les sociétés, Modèle 111, rappels d'échéances et contrôle de la qualité des données.",
    pasarPro: "Passer à Pro",
    modelo: " (modèle {{m}})",
    pagos: "acomptes : modèle {{m}}",
    corregido: "Corrigé manuellement · modifier",
    detectado: "Détecté automatiquement · corriger",
    faltan: "Il manque votre donnée fiscale ({{que}}) : nous supposons territoire commun et indépendant jusqu'à ce que vous la complétiez.",
    cp: "code postal", nif: "NIF/CIF", y: " et ",
    foral: "Votre domicile fiscal est situé en {{nombre}} : la TVA et les acomptes se déclarent auprès de la {{hacienda}}, avec ses propres modèles et échéances forales. Ce brouillon sert de guide ; votre comptable prépare la déclaration.",
    ipsi: "À Ceuta et Melilla, l'IPSI s'applique à la place de la TVA. NuvliPro ne la calcule pas encore : demandez à votre comptable de préparer la déclaration.",
  },
  card: {
    baseVentas: "Base ventes", baseGastos: "Base dépenses", rep: "{{imp}} collectée", sop: "{{imp}} déductible",
    irpf: "Retenue d'impôt (IRPF)", horas: "Heures travaillées", bases: "Bases par taux de {{imp}}", base: "{{imp}} {{pct}}% · base",
    resultado: "Résultat {{imp}} ({{estado}})", aIngresar: "à payer", aCompensar: "à reporter",
    igicCanarias: "IGIC · chantiers aux Canaries", ivaFuera: "TVA · chantiers hors des Canaries",
    ipsiRep: "IPSI collectée", ipsiAviso: "IPSI non calculée : votre comptable la prépare.",
    isp: "Autoliquidation · à part", ispEmitidas: "Émises (base, sans taxe)", ispRecibidas: "Reçues (base)",
    ispCuota: "Taxe autoliquidée (déclarée et déduite)",
  },
  btn: {
    docGestoria: "Doc. comptable", docAnual: "Doc. comptable (annuel)", enviar: "Envoyer", m: "M.{{m}}", modelo: "Modèle {{m}}",
    m420Pro: "Modèle 420 : offre Pro", excel: "Excel", ver130: "Voir 130",
  },
  anual: { titulo: "Bilan annuel {{year}}", ipsi: "IPSI collectée (non calculée)", resultado: "Résultat {{imp}} annuel" },
  doc: { gestoria: "Document pour le comptable", modelo: "Modèle {{m}}" },
  toast: {
    generado: "{{doc}} généré", trimestre: " (T{{n}})", anual: " (annuel {{year}})", error: "Impossible de générer : {{doc}}",
    excelOk: "Rapport {{year}} exporté pour le comptable (XLSX)", excelError: "Impossible d'exporter le rapport",
    m130Error: "Impossible de calculer le Modèle 130", reduccionError: "Impossible d'enregistrer la réduction",
  },
  m130: {
    titulo: "Modèle 130 — Impôt sur le revenu", acum: "(cumul T{{n}})", anual: "(annuel {{year}})",
    desc: "Acompte cumulé de l'année, moins les retenues et les montants payés les trimestres précédents.",
    ingresos: "Recettes imposables (cumul)", gastos: "Charges déductibles (cumul)", rendimiento: "Revenu net",
    reduccion: "Réduction {{pct}} % frais difficiles à justifier", pago: "Acompte ({{pct}} %)",
    retenciones: "Retenues subies", anteriores: "Paiements des trimestres précédents",
    aIngresar: "Résultat à payer", negativo: "Résultat négatif (à payer : 0 €)",
    marcar: "Appliquer la réduction de {{pct}} % pour frais difficiles à justifier (max. {{max}}/an). Vérifiez avec votre comptable.",
    cerrar: "Fermer", pdf: "Télécharger le PDF",
  },
  m202: {
    titulo: "Modèle 202 — acomptes {{year}} (estimation)",
    desc: "Impôt sur les sociétés : {{pct}} % du bénéfice cumulé de l'année. Votre comptable peut utiliser une autre méthode.",
    plazo: "Acompte {{p}} · à déposer du 1er au 20 {{mes}}", mes: { 1: "avril", 2: "octobre", 3: "décembre" },
    tramo: { 3: "janv.–mars", 9: "janv.–sept.", 11: "janv.–nov." }, beneficio: "Bénéfice cumulé ({{tramo}})",
    cuota: "{{pct}} % du bénéfice", menos: "Retenues et acomptes précédents", estimacion: "Estimation à payer",
  },
  m111: {
    titulo: "Modèle 111 — retenues {{year}}",
    desc: "Retenues sur les salaires (saisies par vous) et sur les professionnels que vous payez avec retenue (issues de vos dépenses).",
    nominas: "Retenues sur salaires (manuel)", profesionales: "Professionnels : {{n}} bénéficiaire(s), base {{base}}",
    total: "Total à payer", guardado: "Retenues sur salaires du T{{n}} enregistrées",
    errorGuardar: "Impossible d'enregistrer le montant", invalido: "Saisissez un montant valide, par exemple 1 234,56",
  },
  enviar: {
    titulo: "Envoyer le T{{n}} {{year}} à votre comptable",
    desc: "Il recevra un e-mail avec ces PDF en pièce jointe. S'il répond, l'e-mail vous parviendra.",
    email: "E-mail du comptable", placeholder: "comptable@exemple.fr", boton: "Envoyer", ok: "T{{n}} {{year}} envoyé à {{email}} ({{docs}} PDF)",
    error: "Vérifiez l'e-mail du comptable",
  },
  avisos: {
    plazos: "Prochaines échéances", sinPlazos: "Aucune échéance à venir.",
    forales: "Échéances forales : les modèles se déposent auprès de votre Hacienda Foral et votre comptable les prépare.",
    modelos: "Modèles {{m}}", rango: "{{periodo}} : du {{desde}} au {{hasta}}",
    hoy: "Se termine aujourd'hui", unDia: "Il reste 1 jour", dias: "Il reste {{n}} jours",
    recordatorio: "Nous vous prévenons par notification et e-mail 10 jours avant la fin de chaque échéance.",
    calidad: "Qualité des données {{year}}", ok: "Tout est en ordre : aucune donnée ne manque dans vos factures de cette année.",
    revisar: "Vérifier", exenta: "Marquer comme exonérée", exentaOk: "Dépense marquée comme exonérée", exentaError: "Impossible de marquer la dépense",
  },
  calidad: {
    facturas_nif: "Factures émises sans NIF du client ou avec un NIF incorrect",
    facturas_cp_obra: "Factures de chantier sans code postal du chantier (ajoutez-le dans la fiche du chantier)",
    gastos_sin_impuesto: "Factures reçues sans taxe détaillée (TVA ou IGIC à 0)",
    gastos_nif: "Factures reçues sans NIF du fournisseur ou avec un NIF incorrect",
  },
  ajustes: {
    titulo: "Régime fiscal (Bilan trimestriel)", det1: "Détecté automatiquement :", det2: "selon votre code postal et",
    det3: "selon votre NIF/CIF. Ne le modifiez que s'il est incorrect.",
    nota: "Ce changement ne concerne que le Bilan trimestriel. Les nouvelles factures continuent de proposer la taxe selon votre code postal et celui du client.",
    territorio: "Territoire fiscal", tipo: "Type de contribuable", automatico: "Automatique ({{x}})",
    autonomo130: "Indépendant (modèle 130)", sociedad202: "Société (modèle 202)",
    bloqueado: "Le régime automatique fait partie de l'offre Pro.", guardado: "Régime fiscal enregistré", error: "Impossible d'enregistrer",
  },
};

export default fr;
